import { RegistrationSuccessPageCombinedProps } from './types';

const usePresenter = (props: RegistrationSuccessPageCombinedProps): RegistrationSuccessPageCombinedProps => {
  return props;
};

export default usePresenter;
